export interface ExamplePreset {
  id: number;
  name: string;
  preview: string;
  results: string[];
}

export const examplePresets: ExamplePreset[] = [
  {
    id: 1,
    name: 'Western Dress',
    preview:
      'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-ghost-mannequin%2F2025-Women-s-Western-Cowgirl-Suede-Dress-Vintage-Long-Sleeve-Slim-Fit-Fringe-Dress-Formal-Dresses-with-Lapel-and-Zip_b24eb095-b897-44c2-97de-54f29fce70b3.093c4e034e7c8fb4ca2aa390ba44a7cc-3085906459.jpg?alt=media&token=5e668791-9d19-472c-8cd4-4ac8784c3b6a',
    results: [
      'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-ghost-mannequin%2Fghost-mannequin-output-1.jpeg?alt=media&token=b26353af-9996-467a-ab33-931be1dc217e',
    ],
  },
  {
    id: 2,
    name: 'Denim Layered Look',
    preview:
      'https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/ai_ghost_mannequin_images/Yqsl85WkdWellAJHbVgrZhu9lBS2/62b76ad4-e522-4503-9e42-eb7e1a89d99a.webp/b19b41e1-d3a7-45bb-af27-4c8f45935a4c',
    results: [
      'https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/photohsoot_images/Yqsl85WkdWellAJHbVgrZhu9lBS2/ec79850d-02f5-4537-aa6c-f0069f57e54f/82d28b68-ef9b-49c8-a60a-a059846c7a51',
    ],
  },
];
